"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefPromise = void 0;
var _react = require("react");
var useRefPromise = exports.useRefPromise = function useRefPromise(initialRefValue) {
  var ref = (0, _react.useRef)(initialRefValue);
  var promiseRef = (0, _react.useRef)({
    promise: null,
    resolve: null
  });
  var setRef = (0, _react.useCallback)(function (refValue) {
    ref.current = refValue;
    if (promiseRef.current.promise) {
      promiseRef.current.resolve(ref);
      promiseRef.current = {
        promise: null,
        resolve: null
      };
    }
  }, []);
  var getRefPromise = (0, _react.useCallback)(function () {
    if (ref.current !== initialRefValue) {
      return Promise.resolve(ref);
    }
    if (promiseRef.current.promise) {
      return promiseRef.current.promise;
    }
    var resolve = null;
    var promise = new Promise(function (res) {
      resolve = res;
    });
    promiseRef.current = {
      promise: promise,
      resolve: resolve
    };
    return promise;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return {
    getRefPromise: getRefPromise,
    setRef: setRef
  };
};